import React, { useState, useEffect } from 'react';
import { ThemeProvider } from './components/providers/ThemeProvider';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { useMedia } from 'react-use';
import ModernMapView from './components/maps/MapView';
import QRCodePanel from './components/QRCodePanel';
import ModernDashboard from './components/dashboard/ModernDashboard';
import SustainabilityIndex from './components/SustainabilityIndex';
import CropEvaluation from './components/CropEvaluation';
import SettingsView from './components/SettingsView';
// PRD Feature Components
import BiodiversityDashboard from './components/BiodiversityDashboard';
import SatelliteNDVIPanel from './components/SatelliteNDVIPanel';
import PestPredictionDashboard from './components/PestPredictionDashboard';
import { TooltipProvider } from './components/ui/tooltip';
// i18n initialization
import { initializeLanguage } from './services/i18nService';
import './styles/index.css';
import './styles/sustainability.css';

function App() {
  const [showQRCode, setShowQRCode] = useState(false);
  const [activeView, setActiveView] = useState('map');
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobile = useMedia('(max-width: 768px)', false);

  const handleViewChange = (view, fieldId = null) => {
    setActiveView(view);
    if (fieldId) setSelectedFieldId(fieldId);
  };

  // Initialize i18n on app load
  useEffect(() => {
    initializeLanguage();
  }, []);

  const renderActiveView = () => {
    switch (activeView) {
      case 'settings':
        return <SettingsView />;
      case 'map':
        return <ModernMapView onViewChange={handleViewChange} />;
      case 'charts':
        return <ModernDashboard initialFieldId={selectedFieldId} />;
      case 'sustainability':
        return <SustainabilityIndex />;
      case 'evaluation':
        return <CropEvaluation />;
      case 'biodiversity':
        return <BiodiversityDashboard />;
      case 'satellite':
        return <SatelliteNDVIPanel initialFieldId={selectedFieldId} />;
      case 'pest':
        return <PestPredictionDashboard />;
      default:
        return <ModernMapView onViewChange={handleViewChange} />;
    }
  };

  return (
    <ThemeProvider defaultTheme="dark" storageKey="agrotrack-theme">
      <TooltipProvider>
        <div className="flex h-screen w-screen flex-col overflow-hidden bg-background">
          <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
          <div className="flex flex-1 overflow-hidden">
            <Sidebar
              activeView={activeView}
              onViewChange={handleViewChange}
              isMobile={isMobile}
              isOpen={sidebarOpen}
              onOpenChange={setSidebarOpen}
            />
            <main className="flex-1 overflow-y-auto">
              <div className="h-full w-full">
                {renderActiveView()}
              </div>
            </main>
          </div>

          {showQRCode && (
            <QRCodePanel onClose={() => setShowQRCode(false)} />
          )}
        </div>
      </TooltipProvider>
    </ThemeProvider>
  );
}

export default App;
